import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class appHeaderPwa_template extends vnTemplate {

    protected getTemplateHtml(): string {

        return `
        <div class="pwa-header">
            <button class="icon i-menu-pwa"></button>
            <img style="height: 2.86rem;" class="logo" src="/assets/images/logo-old.svg">
            <button class="icon i-user"></button>
        </div>
        <div data-bind="css: brandClass" class="brand-accent"></div>
        <div class="w-header-title">
            <span class="page-title-logo-pwa dark" data-bind="css: brandClass"></span>
            <h2 class="page-title logo">
                <span style="font-size: 1.2rem; color: #ff385a" data-bind="text: headerTitle"></span>
            </h2>
        </div>
            `;
    }

    protected getTemplateName(): string {
        return "appHeaderPwa-template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-pwa-header"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            userPicture: ko.observable(""),
            userFullName: ko.observable(""),
            profileLink: ko.observable(""),
            projectsCount: ko.observable(""),
            totalEarnings: ko.observable(""),
            headerTitle: ko.observable(""),
            brandClass: ko.observable(""),
            brandName: ko.observable(""),
            brandDomain:  ko.observable(""),
            isUserStatsVisible: ko.observable(false),
            menuItems: ko.observableArray([]),
            onClickLogOutAction: function (data, event) {
                huit_neuf_this.onClickLogOutAction();
            },
            onClick: function(){ huit_neuf_this.onClick(); }
        };
    }

    public setUserImageSrc(src: string): void {
        this.viewModel[this.idElement].userPicture(src);
    }

    public setUserFullName(fullName: string): void {
        this.getTemplateViewModel().userFullName(fullName);
    }

    public setProfilePageLink(link: string): void {
        this.getTemplateViewModel().profileLink(link);
    }

    public setProjectsCount(projectsCount: number): void {
        this.getTemplateViewModel().projectsCount(projectsCount);
    }

    public setTotalEarnings(totalEarnings: string): void {
        this.getTemplateViewModel().totalEarnings(totalEarnings);
    }

    public setIsUserStatsVisible(isUserStatsVisible: boolean): void {
        this.getTemplateViewModel().isUserStatsVisible(isUserStatsVisible);
    }

    public setHeaderTitle(title: string) {
        this.getTemplateViewModel().headerTitle(title);
    }

    public setBrandClass(brandClass: string) {
        this.getTemplateViewModel().brandClass(brandClass);
    }

    public setBrandName(brandName: string) {
        this.getTemplateViewModel().brandName(brandName);
    }

    public setBrandDomain(brandDomain: string) {
        this.getTemplateViewModel().brandDomain(brandDomain);
    }

    public setMenuItems(menuItems: Array<Object>): void {
        this.getTemplateViewModel().menuItems(menuItems);
    }

    protected onClickLogOutAction() {
        this.caller.logOut();
    }

    private onClick(){
        if (document.getElementsByClassName('btn-sidebar-pwa')[0].classList.contains("is-closed")) {
            document.getElementsByClassName('btn-sidebar-pwa')[0].classList.remove("is-closed");
            document.getElementsByClassName('sidenav')[0].classList.remove("is-closed");
            document.getElementsByClassName('main-nav-list')[0].classList.add("is-hidden");
            document.getElementById('closedContent').classList.remove("is-closed");
            document.getElementById('closedHeader').classList.remove("is-closed");
            document.getElementById('header').classList.remove("is-closed");
            document.getElementById('closedContent').classList.remove("is-closed");
        } else {

            let selectedElements = document.getElementById('mainNavMenu').getElementsByClassName("is-selected");
            for (let i = 0; i < selectedElements.length; i++) {
                selectedElements[i].classList.remove('is-selected');
            }

            document.getElementsByClassName('btn-sidebar-pwa')[0].classList.add("is-closed");
            document.getElementsByClassName('sidenav')[0].classList.add("is-closed");
            document.getElementById('closedHeader').classList.add("is-closed");
            document.getElementById('header').classList.add("is-closed");
            document.getElementById('closedContent').classList.add("is-closed");
        }

    }
}



// WEBPACK FOOTER //
// ./js/components/templates/appHeaderPwa_template.ts